import { styled } from '@mui/material/styles';

export const StyledLink = styled('a')(({ theme, color }) => ({
  textDecoration: 'none',
  '&, &:active, &:link, &:visited': {
    color: (() => {
      const themeColor = theme.color[color];
      return themeColor ? themeColor.main : color;
    })()
  },
  /* disabled needs to remain last, in case there is also another state present (in that case just the last remains) */
  '&:disabled, &[disabled]': {
    color: theme.color.disabled.text,
    cursor: 'initial',
    pointerEvents: 'none'
  }
}));
